// Opaque branded types — no plain string assignable to either
declare const __logicalMailbox: unique symbol;
export type LogicalMailbox = string & { readonly [__logicalMailbox]: never };

declare const __mailboxAddress: unique symbol;
export type MailboxAddress = string & { readonly [__mailboxAddress]: never };

/** Only for use at true system boundaries (proto decode, config, user input in RpcTestPage). */
export function asMailboxAddress(s: string): MailboxAddress {
  return s as MailboxAddress;
}

export function asLogicalMailbox(s: string): LogicalMailbox {
  return s as LogicalMailbox;
}
